import { render, staticRenderFns } from "./ProductCategoryAdd.vue?vue&type=template&id=22a68ac3"
import script from "./ProductCategoryAdd.vue?vue&type=script&lang=js"
export * from "./ProductCategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryAdd.vue?vue&type=style&index=0&id=22a68ac3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports